import { render, staticRenderFns } from "./MobileOrderCard.vue?vue&type=template&id=0b9fa224&scoped=true&"
import script from "./MobileOrderCard.vue?vue&type=script&lang=js&"
export * from "./MobileOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileOrderCard.vue?vue&type=style&index=0&id=0b9fa224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9fa224",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow})
